import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import * as styleDefinitions from 'styleDefinitions';

const useStyles = makeStyles({
  container: {
    ...styleDefinitions.rightRounded,
    ...styleDefinitions.linearGradient,
  },
  preTitle: {
    fontSize: '16px',
    fontWeight: 600,
    color: 'white',
    fontFamily: 'Museo',
    paddingBottom: '13px',
  },
  title: {
    fontSize: 20,
    color: 'white',
    fontFamily: 'Museo',
    fontWeight: 'bold',
    lineHeight: 1,
  },
});

export default function SectionTitle(props) {
  const classes = useStyles();

  return (
    <Box
      className={classes.container}
      p={{ xs: 2.5, sm: 3, md: 4 }}
      mr={{ xs: 2.5 }}
    >
      {/* TODO: (Damir) use Text component here instead of span */}
      {props.preText && (
        <div className={classes.preTitle}>
          <span>{props.preText}</span>
        </div>
      )}
      <div className={classes.title}>
        <span>{props.text}</span>
      </div>
    </Box>
  );
}

SectionTitle.propTypes = {
  preText: PropTypes.string,
  text: PropTypes.string.isRequired,
};
